import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';

export interface ApiResponse<T> {
  data: T;
  success: boolean;
  draw: number | null;
  recordsTotal: number | null;
  recordsFiltered: number | null;
  errorMessage: string | null;
  currentPage: number | null;
  totalItems: number | null;
  totalPages: number | null;
}

export interface CurrentPicking {
  pickingId: number;
  pickerUserId: number | null;
  pickerFirstName: string | null;
  pickerLastName: string | null;
  routeName: string | null;
  startPickingTime: string | null;
  elapsedMinutes: number | null;
  itemsPicked: number | null;
  totalItems: number | null;
}

export interface ActiveRoute {
  pickingId: number;
  routeName: string | null;
  driverFirstName: string | null;
  driverLastName: string | null;
  status: number;
  itemsRemaining: number | null;
  pickedVM: number | null;
  notPickedVM: number | null;
}

export interface ShortedItem {
  pickingItemId: number;
  pickingId: number;
  productName: string;
  apCode: string;
  quantity: number;
  pickQuantity: number | null;
  routeName: string | null;
  deviceId: string | null;
  // if backend later adds this, keep it optional for now
  qtyShorted?: number;
}

export interface PickerPerformance {
  pickerUserId: number;
  pickerFirstName: string | null;
  pickerLastName: string | null;
  itemsPicked: number | null;
  secondsWorked: number | null;
  routesCompleted: number | null;
}

const buildConfig = () => {
  const token = sessionStorage.getItem('token');
  const headers = token
    ? { Authorization: `${ACCESS_TYPE} ${token}` }
    : undefined;

  return { headers };
};

/**
 * 1) Current picking
 * Backend returns: { data: [CurrentPicking], ... }
 * We'll treat it as array and take first element in the hook.
 */
export const getCurrentPicking = () => {
  const url = `${VENDING_URL}picking/current`;
  const config = buildConfig();
  return axios.get<ApiResponse<CurrentPicking[]>>(url, config);
};

/**
 * 2) Active routes
 * Backend returns: { data: ActiveRoute[], ... }
 */
export const getActiveRoutes = () => {
  const url = `${VENDING_URL}picking/active-routes`;
  const config = buildConfig();
  return axios.get<ApiResponse<ActiveRoute[]>>(url, config);
};

/**
 * 3) Shorted items
 * Backend returns: { data: ShortedItem[], ... }
 */
export const getShortedItems = () => {
  const url = `${VENDING_URL}picking/shorted-items`;
  const config = buildConfig();
  return axios.get<ApiResponse<ShortedItem[]>>(url, config);
};

/**
 * 4) Picker performance
 * Backend returns: { data: PickerPerformance[], ... }
 */
export const getPickerPerformance = () => {
  const url = `${VENDING_URL}picking/picker-performance`;
  const config = buildConfig();
  return axios.get<ApiResponse<PickerPerformance[]>>(url, config);
};
